// frontend/src/api/user.js
// Funciones API para la gestión de usuarios.

import { request } from './api';

/**
 * @function getAllUsers
 * @description Obtiene una lista de todos los usuarios del backend.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<Array<object>>} - Una promesa que resuelve con un array de objetos de usuario.
 */
export async function getAllUsers(token) {
  return request('/api/users', 'GET', null, token);
}

/**
 * @function createUser
 * @description Crea un nuevo usuario en el backend.
 * @param {object} userData - Datos del nuevo usuario (username, password, isAdmin).
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<object>} - Una promesa que resuelve con el usuario creado.
 */
export async function createUser(userData, token) {
  return request('/api/users', 'POST', userData, token);
}

/**
 * @function updateUser
 * @description Actualiza un usuario existente en el backend.
 * @param {string} userId - El ID único del usuario a actualizar.
 * @param {object} userData - Datos actualizados del usuario.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<object>} - Una promesa que resuelve con el usuario actualizado.
 */
export async function updateUser(userId, userData, token) {
  return request(`/api/users/${userId}`, 'PUT', userData, token);
}

/**
 * @function deleteUser
 * @description Elimina un usuario del backend.
 * @param {string} userId - El ID único del usuario a eliminar.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<object>} - Una promesa que resuelve cuando el usuario ha sido eliminado.
 */
export async function deleteUser(userId, token) {
  return request(`/api/users/${userId}`, 'DELETE', null, token);
}
